import { Component, OnInit } from '@angular/core';

import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-manual-confirm-reservation-detail-dialog',
  templateUrl: './manual-confirm-reservation-detail-dialog.component.html',
  styleUrls: ['./manual-confirm-reservation-detail-dialog.component.css'],
  standalone: false,
})
export class ManualConfirmReservationDetailDialogComponent implements OnInit {

  readonly manualTopLink: string = AppConst.ROUTING_LINK_MANUAL_INDEX;

  currentLang: string = 'ja';

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translate.currentLang;
  }

}
